import { Shark, Utils, View } from "shark-mvc";
import { Popover, Tooltip } from "bootstrap";

import TextContent from "../../models/TextContent";
import VolumeCollection from "../../models/VolumeCollection";
import Volume from "../../models/Volume";

import templateContent from "./volume-collection.html";
import "./style.css";

import contentsManager from "../../controllers/contentsManager";
import mainNavComponent from "../../components/mainNav/mainNavComponent";
import volumeCollectionManager from "../../controllers/VolumeCollectionManager";
import volumeManager from "../../controllers/VolumeManager";
import waitBoxComponent from "../../components/waitBox/waitBoxComponent";
import textContentView from "../textContent/textContentView";

class VolumeCollectionView extends View {
	constructor () {
		super("volumeCollectionView");
		this.setTemplate(templateContent);

		this.route = "collections";
	}

	addNewVolumeBtn_clickHandler () {
		if (!Shark.$store.selectedVolumeCollection) {
			alert("Devi selezionare una Collezione per inserire un Volume.");
			return;
		}

		const newVolume = new Volume({
			referenceCollections: [Shark.$store.selectedVolumeCollection.guid],
			status: 1,
			title: "Nuovo Volume",
		});

		Shark.set({
			currVolume: newVolume,
		});
	}

	addNewVolumeCollectionBtn_clickHandler () {
		const newVolumeCollection = new VolumeCollection({
			title: "Nuova Collezione",
		});

		Shark.set({
			currVolumeCollection: newVolumeCollection,
		});
	}

	afterRender () {
		const popoverTriggerList = document.querySelectorAll(`[data-bs-toggle="popover"]`);
		[...popoverTriggerList].map(popoverTriggerEl => new Popover(popoverTriggerEl));

		const tooltipTriggerList = document.querySelectorAll(`[data-bs-toggle="tooltip"]`);
		[...tooltipTriggerList].map(popoverTriggerEl => new Tooltip(popoverTriggerEl));
	}

	beforeLoad () {
		this.refreshLists();
	}

	cancelCurrVolumeCollectionBtn_clickHandler () {
		const { currVolumeCollection } = Shark.get();

		if (!currVolumeCollection.isDirty() || confirm("Vuoi davvero annulare? Le modifiche inserite andranno perdute!")) {
			currVolumeCollection.restore();
			Shark.$store.currVolumeCollection = null;
		}
	}

	cancelCurrVolumeEditBtn_clickHandler () {
		const { currVolume } = Shark.get();

		if (!currVolume.isDirty() || confirm("Vuoi davvero annulare? Le modifiche inserite andranno perdute!")) {
			currVolume.restore();
			Shark.$store.currVolume = null;
		}
	}

	// deleteCurrVolumeCollectionBtn_clickHandler () {
	// 	const { currVolumeCollection } = Shark.get();

	// 	if (true) {

	// 	}
	// }

	async deleteVolumeBtn_clickHandler (event, data) {
		const { volumeList } = Shark.get();
		const selectedVolume = Utils.safp(volumeList, "guid", data.guid);

		if (selectedVolume && confirm(`Vuoi davvero eliminare "${selectedVolume.title}"? Non sarà possibile annullare l'operazione!`)) {
			waitBoxComponent.open();
			
			const result = await volumeManager.delete(selectedVolume);
			console.log({result});
			
			await this.getVolumesByVolumeCollectionGuid(Shark.$store.selectedVolumeCollection.guid);
			
			waitBoxComponent.close();
		}
	}

	async deleteVolumeCollectionBtn_clickHandler (event, data) {
		const { volumeCollectionList } = Shark.get();
		const selectedVolumeCollection = Utils.safp(volumeCollectionList, "guid", data.guid);

		if (selectedVolumeCollection && confirm(`Vuoi davvero eliminare "${selectedVolumeCollection.title}"? Non sarà possibile annullare l'operazione!`)) {
			waitBoxComponent.open();
			
			const result = await volumeCollectionManager.delete(selectedVolumeCollection);
			console.log({result});
			
			await this.refreshLists();
			
			waitBoxComponent.close();
		}
	}

	editContentBtn_clickHandler (event, data) {
		if (data.guid) {
			this.viewContent(data.guid);
		}
	}

	editVolumeBtn_clickHandler (event, data) {
		const { volumeList } = Shark.get();
		const selectedVolume = Utils.safp(volumeList, "guid", data.guid);

		if (selectedVolume) {
			volumeList.forEach(item => item._CSSClasses = item.guid === selectedVolume.guid ? "list-group-item-info" : "");
			
			Shark.set({
				currVolume: selectedVolume,
				volumeList,
			});
		}
	}

	editVolumeCollectionBtn_clickHandler (event, data) {
		const { volumeCollectionList } = Shark.get();
		const selectedVolumeCollection = Utils.safp(volumeCollectionList, "guid", data.guid);

		if (selectedVolumeCollection) {
			volumeCollectionList.forEach(item => item._CSSClasses = item.guid === selectedVolumeCollection.guid ? "list-group-item-info" : "");
			
			Shark.set({
				currVolumeCollection: selectedVolumeCollection,
				volumeCollectionList,
			});
		}
	}

	filterVolumes () {
		const { volumeCollectionViewFilters: filters, volumeCompleteList } = Shark.get();

		const volumeList = volumeCompleteList.filter(item => {
			return ((filters.showVolumeNotStarted && item.status === 1) || (filters.showVolumePending && [2, 4].includes(item.status)) || (filters.showVolumeComplete && item.status === 3)) &&
			(item.title.toLowerCase().includes(filters.volumeSearchKey.toLowerCase()) || item.subtitle.toLowerCase().includes(filters.volumeSearchKey.toLowerCase()));
		});

		Shark.set({
			volumeList,
		});
	}

	async getContentsByVolumeGuid (volumeGuid) {
		waitBoxComponent.open();
		
		const contentListResult = await contentsManager.getListByVolumeGuid(volumeGuid);
		// const imageContentList = Shark.getInstanceList(TextContent, contentListResult.data.images);
		// const placeContentList = Shark.getInstanceList(TextContent, contentListResult.data.places);
		const textContentList = Shark.getInstanceList(TextContent, contentListResult.data.texts);

		const contentList = textContentList;
		contentList.sort((a, b) => {
			let sort = a.hierarchicalLevel - b.hierarchicalLevel;

			if (sort === 0) {
				sort = a.__pageTagsLabel > b.__pageTagsLabel ? 1 : -1;
			}

			return sort;
		});

		Shark.set({
			contentCompleteList: [...contentList],
			contentList,
		});

		waitBoxComponent.close();
	}

	async getVolumesByVolumeCollectionGuid (volumeCollectionGuid) {
		waitBoxComponent.open();
		
		const volumeListResult = await volumeManager.getListByVolumeCollectionGuid(volumeCollectionGuid);
		const volumeList = Shark.getInstanceList(Volume, volumeListResult.data);

		volumeList.sort((a, b) => {
			return a.title.toLowerCase() > b.title.toLowerCase() ? 1 : -1;
		});

		Shark.set({
			currVolume: null,
			volumeCompleteList: [...volumeList],
			volumeList,
		});

		this.filterVolumes();

		waitBoxComponent.close();
	}

	init () {
		this.addComponents([mainNavComponent, waitBoxComponent]);

		const volumeCollectionViewFiltersRawData = localStorage.volumeCollectionViewFilters;
		let volumeCollectionViewFiltersData;

		if (volumeCollectionViewFiltersRawData) {
			volumeCollectionViewFiltersData = JSON.parse(volumeCollectionViewFiltersRawData);
		}

		const volumeCollectionViewFilters = Shark.getInstance("__smart__", {
			contentSearchKey: "",
			showVolumeComplete: volumeCollectionViewFiltersData ? volumeCollectionViewFiltersData.showVolumeComplete : true,
			showVolumeNotStarted: volumeCollectionViewFiltersData ? volumeCollectionViewFiltersData.showVolumeNotStarted : false,
			showVolumePending: volumeCollectionViewFiltersData ? volumeCollectionViewFiltersData.showVolumePending : true,
			volumeSearchKey: "",
			onDataChanged: data => {
				console.log(data);
				
				localStorage.setItem("volumeCollectionViewFilters", JSON.stringify(volumeCollectionViewFilters));

				const { contentCompleteList } = Shark.get();

				if (data.property.toLowerCase().includes("volume")) {
					this.filterVolumes();
				}
				else if (data.property === "contentSearchKey") {
					const contentList = contentCompleteList.filter(item => {
						return item.title.toLowerCase().includes(volumeCollectionViewFilters.contentSearchKey.toLowerCase()) ||
						item.abstract.toLowerCase().includes(volumeCollectionViewFilters.contentSearchKey.toLowerCase()) ||
						item.textBody.toLowerCase().includes(volumeCollectionViewFilters.contentSearchKey.toLowerCase());
					});

					Shark.set({
						contentList,
					});
				}
			},
		});

		Shark.set({
			contentCompleteList: [],
			contentList: [],
			currVolume: null,
			currVolumeCollection: null,
			selectedVolumeCollection: null,
			volumeCollectionList: [],
			volumeCollectionViewFilters,
			volumeCompleteList: [],
			volumeList: [],
		});
	}

	resetContentSearchFieldBtn_clickHandler () {
		const { volumeCollectionViewFilters } = Shark.get();

		volumeCollectionViewFilters.set({
			contentSearchKey: "",
		});
	}

	resetVolumeSearchFieldBtn_clickHandler () {
		const { volumeCollectionViewFilters } = Shark.get();

		volumeCollectionViewFilters.set({
			volumeSearchKey: "",
		});
	}

	async refreshLists () {
		waitBoxComponent.open();
		
		const volumeCollectionListResult = await volumeCollectionManager.getList();
		const volumeCollectionList = Shark.getInstanceList(VolumeCollection, volumeCollectionListResult.data);

		volumeCollectionList.sort((a, b) => {
			if (a.title.toLowerCase() > b.title.toLowerCase()) {
				return 1;
			}
			else if (a.title.toLowerCase() < b.title.toLowerCase()) {
				return -1;
			}
			else {
				a.subtitle.toLowerCase() > b.subtitle.toLowerCase() ? 1 : -1;
			}
		});

		Shark.set({
			currVolumeCollection: null,
			volumeCollectionList,
		});

		waitBoxComponent.close();
	}

	refreshVolumeListBtn_clickHandler () {
		if (Shark.$store.selectedVolumeCollection.guid) {
			this.getVolumesByVolumeCollectionGuid(Shark.$store.selectedVolumeCollection.guid);
		}
	}

	async saveCurrVolumeBtn_clickHandler () {
		const { currVolume } = Shark.get();

		if (currVolume) {
			waitBoxComponent.open();
			
			const result = await volumeManager.save(currVolume);
			console.log({result});
			
			await this.getVolumesByVolumeCollectionGuid(Shark.$store.selectedVolumeCollection.guid);
			
			waitBoxComponent.close();
		}
	}

	async saveCurrVolumeCollectionBtn_clickHandler () {
		const { currVolumeCollection } = Shark.get();

		if (currVolumeCollection) {
			waitBoxComponent.open();
			
			const result = await volumeCollectionManager.save(currVolumeCollection);
			console.log({result});
			
			await this.refreshLists();
			
			waitBoxComponent.close();
		}
	}

	selectVolumeBtn_clickHandler (event, data) {
		const { volumeList } = Shark.get();
		const selectedVolume = Utils.safp(volumeList, "guid", data.guid);

		if (selectedVolume) {
			volumeList.forEach(item => item._CSSClasses = item.guid === selectedVolume.guid ? "list-group-item-info" : "");
			
			Shark.set({
				selectedVolume,
				volumeList,
			});

			this.getContentsByVolumeGuid(selectedVolume.guid);
		}
	}

	selectVolumeCollectionBtn_clickHandler (event, data) {
		const { volumeCollectionList } = Shark.get();
		const selectedVolumeCollection = Utils.safp(volumeCollectionList, "guid", data.guid);

		if (selectedVolumeCollection) {
			volumeCollectionList.forEach(item => item._CSSClasses = item.guid === selectedVolumeCollection.guid ? "list-group-item-info" : "");
			
			Shark.set({
				contentList: [],
				currVolume: null,
				selectedVolumeCollection,
				volumeCollectionList,
			});

			this.getVolumesByVolumeCollectionGuid(selectedVolumeCollection.guid);
		}
	}

	viewContent (contentGuid) {
		waitBoxComponent.open();

		const currContent = Utils.safp(Shark.$store.contentList, "guid", contentGuid);

		if (currContent) {
			Shark.set({
				currContent,
			});

			let destView = textContentView;

			Shark.openPage(destView, {urlSearchParams: { coguid: currContent.guid } });
		}
	}

	viewContentBtn_clickHandler (event, data) {
		if (data.guid) {
			this.viewContent(data.guid);
		}
	}
}

const volumeCollectionView = new VolumeCollectionView();

Shark.registerView(volumeCollectionView);

export default volumeCollectionView;
